var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "qty-box d-flex h-100" }, [
    _c("input", {
      ref: "quantityInputField",
      staticClass: "qty-input text-center",
      attrs: {
        type: "text",
        disabled: _vm.waiting,
        "aria-label": _vm.$translate("Ceres::Template.itemQuantityInput")
      },
      domProps: { value: _vm.displayValue },
      on: {
        change: function($event) {
          return _vm.setValue($event.target.value)
        }
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "qty-btn-container d-flex flex-column" }, [
      _c(
        "button",
        {
          directives: [
            {
              name: "tooltip",
              rawName: "v-tooltip",
              value: _vm.isMaximum && _vm.compMax !== 0,
              expression: "isMaximum && compMax !== 0"
            }
          ],
          staticClass:
            "btn qty-btn flex-fill d-flex justify-content-center p-0",
          class: {
            disabled: _vm.isMaximum || _vm.waiting,
            "btn-appearance": _vm.useAppearance
          },
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "data-testing": "quantity-btn-increase",
            title: _vm.maximumHint,
            "aria-label": _vm.$translate(
              "Ceres::Template.itemQuantityInputIncrease"
            )
          },
          on: {
            click: function($event) {
              return _vm.increaseValue()
            }
          }
        },
        [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "10",
                height: "6.069",
                viewBox: "0 0 10 6.069"
              }
            },
            [
              _c("path", {
                attrs: {
                  id: "chevron-right-solid",
                  d:
                    "M5.908,5.389l-4.45,4.45a.55.55,0,0,1-.777,0L.161,9.32a.55.55,0,0,1,0-.776L3.687,5,.16,1.456a.55.55,0,0,1,0-.776L.68.161a.55.55,0,0,1,.777,0l4.45,4.45A.55.55,0,0,1,5.908,5.389Z",
                  transform: "translate(0 6.069) rotate(-90)",
                  fill: "#464646"
                }
              })
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          directives: [
            {
              name: "tooltip",
              rawName: "v-tooltip",
              value: _vm.isMinimum && _vm.compMax !== 0,
              expression: "isMinimum && compMax !== 0"
            }
          ],
          staticClass:
            "btn qty-btn flex-fill d-flex justify-content-center p-0",
          class: {
            disabled: _vm.isMinimum || _vm.waiting,
            "btn-appearance": _vm.useAppearance
          },
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "bottom",
            "data-testing": "quantity-btn-decrease",
            title: _vm.minimumHint,
            "aria-label": _vm.$translate(
              "Ceres::Template.itemQuantityInputDecrease"
            )
          },
          on: {
            click: function($event) {
              return _vm.decreaseValue()
            }
          }
        },
        [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "10",
                height: "6.069",
                viewBox: "0 0 10 6.069"
              }
            },
            [
              _c("path", {
                attrs: {
                  id: "chevron-right-solid",
                  d:
                    "M5.908,5.389l-4.45,4.45a.55.55,0,0,1-.777,0L.161,9.32a.55.55,0,0,1,0-.776L3.687,5,.16,1.456a.55.55,0,0,1,0-.776L.68.161a.55.55,0,0,1,.777,0l4.45,4.45A.55.55,0,0,1,5.908,5.389Z",
                  transform: "translate(10) rotate(90)",
                  fill: "#464646"
                }
              })
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }